import { type UserDataType } from '@app-types/UserDataType'
import { renderKuran } from '@components/Kuran/KelimeMealliPage/KuranPage'
import QuranLearningMode from '@components/Kuran/QuranLearningMode/QuranLearningMode'
import QuranMealPage from '@components/Kuran/QuranMealPage/QuranMealPage'
import MealliKuranPage from '@components/Kuran/MealliKuranPage/MealliKuranPage'
import React from 'react'

const ayahs = [
  {
    id: 5992,
    surah: {
      id: 88,
      name: 'Gaşiye',
      slug: 'gasiye',
      verse_count: 26,
      pageNumber: 591,
      name_original: 'سورة الغاشية',
      audio: {
        mp3: 'https://archive.org/download/INDIRILIS_SIRASINA_GORE_SESLI_KURAN_MEALI/68-gasiye.mp3',
        duration: 98,
      },
    },
    verse_number: 25,
    verse: 'إِنَّ إِلَيْنَا إِيَابَهُمْ',
    zero: null,
    juzNumber: 30,
    transcription: 'İnne ileyna iyabehum.',
    translation: 'Elbet onların dönüşü Bize olacaktır.',
    words: [
      {
        arapca: 'اِنَّ',
        meal: 'şüphesiz',
        type: 'ayah' as const,
        ayahNum: '25'
      },
      {
        arapca: 'اِلَيْنَٓا',
        meal: 'bizedir',
        type: 'ayah' as const,
        ayahNum: '25'
      },
      {
        arapca: 'اِيَابَهُمْۙ',
        meal: 'dönüşleri',
        type: 'ayah' as const,
        ayahNum: '25'
      },
      {
        type: 'separator' as const,
        separator: '﴿٢٥﴾ ',
        ayahNum: '25',
        arapca: '',
        meal: ''
      },
    ],
    words_with_sound: [
      {
        translation: 'şüphesiz',
        audio_url: 'wbw/088_025_001.mp3',
        arabic: 'إِنَّ',
        type: 'word' as const,
      },
      {
        translation: 'bizedir',
        audio_url: 'wbw/088_025_002.mp3',
        arabic: 'إِلَيْنَآ',
        type: 'word' as const,
      },
      {
        translation: 'dönüşleri',
        audio_url: 'wbw/088_025_003.mp3',
        arabic: 'إِيَابَهُمْ',
        type: 'word' as const,
      },
      {
        translation: '(25)',
        audio_url: '',
        arabic: '﴿٢٥﴾',
        type: 'end' as const,
      },
    ],
    meal_diyanet: "Doğrusu onların dönüşü Bize'dir.",
    muhtasar_tefsir:
      'Şüphesiz ölümlerinin ardından onların dönüşü bir tek bize olacaktır.',
    sajdah_number: null,
    timestamps: { timestamp_from: 22 },
  },
]

const KuranSample = ({ userData }: { userData: UserDataType }) => {
  const hideMeal = userData.kuranMealType !== 'show'
  const hideTooltip = userData.kuranTooltip !== 'show'

  if (userData.kuranType === 'only-meal') {
    // @ts-ignore
    return <QuranMealPage ayahs={ayahs} hideMeal={hideMeal} hideTooltip={hideTooltip} />
  }
  if (userData.kuranType === 'default') {
    return <div>{renderKuran({ userData, ayahs, hideMeal, hideTooltip })}</div>
  }

  if (userData.kuranType === 'learning') {
    return (
      // @ts-ignore
      <QuranLearningMode ayahs={ayahs} hideMeal={hideMeal} hideTooltip={hideTooltip} />
    )
  }

  if (userData.kuranType === 'mealli') {
    return <MealliKuranPage ayahs={ayahs} />
  }

  return null
}

export default KuranSample
